import type { AgentSession, ToolCall } from './agents/types';

export interface PendingApproval {
  sessionId: string;
  messageId: string;
  toolCall: ToolCall;
}

/**
 * Walk a session and find all tool-call parts in `requires_approval` state.
 * Order is chronological — first message → first part wins.
 */
export function pendingApprovalsForSession(session: AgentSession): PendingApproval[] {
  const out: PendingApproval[] = [];
  for (const msg of session.messages) {
    for (const part of msg.parts) {
      if (part.type === 'tool-call' && part.toolCall.status === 'requires_approval') {
        out.push({ sessionId: session.id, messageId: msg.id, toolCall: part.toolCall });
      }
    }
  }
  return out;
}
